module.exports = "<span [@visibilityChanged]=\"isVisible\">\r\n    <ng-content></ng-content>\r\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/fader/fader.component.html
// module id = ./src/app/shared/fader/fader.component.html
// module chunks = main